export default __webpack_public_path__ + "images/0x172370d5cd63279efa6d502dab29171933a610af.png";